"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNamedIdLabel = formatNamedIdLabel;
exports.formatOrderDisplayLabel = formatOrderDisplayLabel;
function formatNamedIdLabel(id, name) {
    return `${name} (#${id})`;
}
function formatOrderDisplayLabel({ id, buyerName, sellerName, }) {
    const name = buyerName ?? sellerName;
    return name === null || name === undefined ? `Order ${id}` : formatNamedIdLabel(id, name);
}
//# sourceMappingURL=display-labels.js.map